import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HeritageSection from './components/HeritageSection';
import FeaturedItems from './components/FeaturedItems';
import Newsletter from './components/Newsletter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <HeritageSection />
        <FeaturedItems />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}